import * as core from '../../../../../../../core'

import { query } from './track-score-details.query'

export const RESOURCE = {
  payload: {
    alias: 'track-score-details',
    description: 'Shows the Track Score Details for a given Track.',
    name: 'Track Score Details',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
